import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { handleBuyClick } from './utils/metaPixel';
export const OfferBlock = () => {
  return <section id="oferta" className="py-24 bg-dark relative overflow-hidden scroll-mt-16" data-id="element-80">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-neon/10 rounded-full blur-[100px] pointer-events-none" data-id="element-81" />

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-82">
        {/* Price card */}
        <div className="bg-dark-card border border-neon/30 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(163,255,18,0.1)] mb-16" data-id="element-83">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-84">
            {/* Image */}
            <div className="flex-1 w-full max-w-sm lg:max-w-none" data-id="element-85">
              <FadeIn data-id="element-86">
                <img src="https://cdn.magicpatterns.com/uploads/i98tbdWAFmDMydmCtG4nes/efectivo_inmediato_48_horas.png" alt="Plan de Emergencia Financiera de 48 Horas" className="w-full h-auto drop-shadow-2xl" data-id="element-87" />
              </FadeIn>
            </div>

            {/* Content */}
            <div className="flex-1 text-center lg:text-left w-full" data-id="element-88">
              <FadeIn delay={0.2} data-id="element-89">
                <h2 className="text-3xl md:text-4xl lg:text-5xl mb-6 leading-tight" data-id="element-90">
                  Accede hoy por solo{' '}
                  <span className="text-neon" data-id="element-91">$6.39 USD</span>
                </h2>

                <p className="text-lg text-gray-300 mb-8 leading-relaxed font-sans" data-id="element-92">
                  Normalmente este tipo de sistemas se venden entre{' '}
                  <span className="text-gray-500 line-through" data-id="element-93">
                    $47 y $97 USD
                  </span>
                  . Por el lanzamiento de esta semana puedes acceder por{' '}
                  <span className="text-white font-semibold" data-id="element-94">$6.39 USD</span>.{' '}
                  <span className="text-[#ADFF2F] font-semibold" data-id="element-95">
                    El viernes el precio sube a $27 USD.
                  </span>
                </p>

                <div id="precio-final" className="mb-6 flex items-baseline gap-3 justify-center lg:justify-start scroll-mt-24" data-id="element-96">
                  <span className="text-6xl md:text-7xl text-neon font-display drop-shadow-[0_0_15px_rgba(163,255,18,0.5)]" data-id="element-97">
                    $6.39
                  </span>
                  <span className="text-2xl text-white" data-id="element-98">USD</span>
                </div>

                <Button className="w-full py-5 text-lg md:text-xl" showIcon={false} onClick={handleBuyClick} data-id="element-99">
                  ⚡ QUIERO ACCESO INMEDIATO POR $6.39
                </Button>
              </FadeIn>
            </div>
          </div>
        </div>

        {/* Closing question */}
        <FadeIn data-id="element-100">
          <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-101">
            <p className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-sm mb-4" data-id="element-102">
              La única pregunta que importa ahora es:
            </p>
            <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-8" data-id="element-103">
              ¿Vas a seguir esperando a que el dinero aparezca solo?{' '}
              <span className="text-neon" data-id="element-104">¿O vas a tomar acción hoy?</span>
            </h2>
          </div>
        </FadeIn>

        {/* Final CTA */}
        <FadeIn delay={0.2} data-id="element-105">
          <div id="cta-final" className="flex flex-col items-center gap-5 scroll-mt-24" data-id="element-106">
            <Button className="w-full sm:w-auto py-5 text-lg md:text-xl" showIcon={false} onClick={handleBuyClick} data-id="element-107">
              ⚡ EMPIEZO HOY POR SOLO $6.39 USD
            </Button>

            <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm text-gray-400" data-id="element-108">
              <span data-id="element-109">🕐 Acceso instantáneo</span>
              <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-110" />
              <span data-id="element-111">✅ Pago seguro</span>
              <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-112" />
              <span data-id="element-113">📥 Descarga inmediata</span>
              <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-114" />
              <span data-id="element-115">🛡️ Garantía 7 días</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};